import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import './ShipOwner.scss'
import * as Observable from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  filter,
  map,
  tap
} from 'rxjs/operators'
import { Main } from '../../../common/components/main/Main'
import { Col, Modal, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap'
import { Table } from '../../../common/components/table/Table'
import { Button } from '../../../common/components/button/Button'
import { Text } from '../../../common/components/text/Text'
import Card from '../../../common/components/card/Card'
import { Grid } from '../../../common/components/grid/Grid'
import { Flex } from '../../../common/components/flex/Flex'
import { Space } from '../../../common/components/space/Space'
import Icons from '../../../common/components/icon/Icon';
import { history } from '../../../store'
import classNames from 'classnames';
import { shipOwnerListGetAction, shipOwnerSetSelectedAction } from '../../../store/action/shipActions';
import { connect } from 'react-redux';
import { format, parseISO } from 'date-fns'
import Filterimg from '../../../assets/images/Filter 2.png'
import { dockService } from '../../../services/dockService';
import { ReactNode } from 'react';
import swal from 'sweetalert'
import { InputWithIcon, Select } from '../../../common/components/control/Control';
import ShipOwnerFilter from './pageContainer/ShipOwnerFilter'
import { ShipFilterState } from '../filter/ShipFilterState'
import Loader from 'react-loader-spinner';
import shipService from '../../../services/shipService';
import sortup from '../../../assets/images/sortup_icon.png'
import sortdown from '../../../assets/images/sortdown_icon.png'
import sortimage from '../../../assets/images/sorting.png'

const ShipOwnerList = (props: any) => {

  const { owners, isLoading, totalElement } = props
  const [displayShipOwners, setShipOwners] = React.useState<any>([])
  const [page, setPage] = React.useState(0)
  const [pagination, setPagination] = React.useState([{}])
  const [searchQuery, setQuery] = React.useState('')
  const [low, setLow] = React.useState(1)
  const [high, setHigh] = React.useState(9)
  const [showModal, setModal] = React.useState(false)
  const [findBy, setFindBy] = React.useState(ShipFilterState.shipOwnerFilter.findbyIdname)
  const [searchSEmail, setSearchSEmail] = React.useState(ShipFilterState.shipOwnerFilter.searchBoxInputEmail)
  const isReq = true
  const [searchInput, setSearchInput] = React.useState(ShipFilterState.shipOwnerFilter.searchBoxInputName)
  const perPage = 9
  var totalPage = Math.ceil(totalElement / 10)
  const [showDelete, setShow] = React.useState(false);
  const [deleteShipOwner, setDeleteShipOwner] = React.useState(0)
  const [sort, setSorting]=React.useState({values:ShipFilterState.shipOwnerFilter.type,direction:ShipFilterState.shipOwnerFilter.direction})


  // React.useEffect(() => {
  //   _addSearchHandlers()
  // }, [])

  React.useEffect(() => {
    props.shipOwnerListGetAction({
      size: 10, page,
      name: ShipFilterState.shipOwnerFilter.name || searchInput,
      fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
      toDate: String(ShipFilterState.shipOwnerFilter.toDate),
      status: ShipFilterState.shipOwnerFilter.shipownstatus,
      type:ShipFilterState.shipOwnerFilter.type,
      direction:ShipFilterState.shipOwnerFilter.direction
    })
  }, [page])

  const role = localStorage.getItem("role");

  const _willShipOwnerFilter = () => {
    setModal(true)
  }

  React.useEffect(() => {
    if (owners && owners.length > 0) {
      setShipOwners(() => {
        return owners.map((s: any) => ({ ...s, checked: false }))
      })
    }
    if (owners && owners.length === 0) {
      setShipOwners([])
    }
  }, [owners])

  React.useEffect(() => {
    const arrayPage = Array.from(Array(totalPage).keys())
    setPagination(arrayPage)
  }, [totalPage])


  const _searchFuntion = (value: string) => {
    setSearchInput(value)
    ShipFilterState.shipOwnerFilter.searchBoxInputName=value;
    props.shipOwnerListGetAction({
      page: 0, size: 10, name: value || ShipFilterState.shipOwnerFilter.searchBoxInputName,
      email: searchSEmail || ShipFilterState.shipOwnerFilter.searchBoxInputEmail,
      fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
      toDate: String(ShipFilterState.shipOwnerFilter.toDate),
      shipownstatus: ShipFilterState.shipOwnerFilter.toDate,
      type:ShipFilterState.shipOwnerFilter.type,
      direction:ShipFilterState.shipOwnerFilter.direction
    })
    setPage(0)
  }

  const _searchSMailFuntion = (value: string) => {
    setSearchSEmail(value)
    ShipFilterState.shipOwnerFilter.searchBoxInputEmail=value;
    props.shipOwnerListGetAction({
      page: 0, size: 10, name: searchInput || ShipFilterState.shipOwnerFilter.name,
      email: value, fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
      toDate: String(ShipFilterState.shipOwnerFilter.toDate),
      shipownstatus: ShipFilterState.shipOwnerFilter.toDate,
      type:ShipFilterState.shipOwnerFilter.type,
      direction:ShipFilterState.shipOwnerFilter.direction
    })
  }
  const _showAllOwner = () => {
    props.shipOwnerListGetAction({ page: 0, size: 10 })
    setSearchInput('')
    setSearchSEmail('')
    ShipFilterState.shipOwnerFilter.page = 0
    ShipFilterState.shipOwnerFilter.size = 10
    ShipFilterState.shipOwnerFilter.fromDate = ''
    ShipFilterState.shipOwnerFilter.toDate = ''
    ShipFilterState.shipOwnerFilter.shipownstatus = ''
    ShipFilterState.shipOwnerFilter.name = ''
    ShipFilterState.shipOwnerFilter.searchBoxInputEmail=''
    setSorting({values:'',direction:''})

  }

  const _getSearchValue = (val: string) => {
    setFindBy(val)
    ShipFilterState.shipOwnerFilter.findbyIdname=val;
  }

  const _willViewDetail = (shipOwner: any) => {
    shipOwnerSetSelectedAction(shipOwner)
    history.push(`/ship-owner/${shipOwner.id}`)
  }

  const _willViewEdit = (shipOwner: any) => {
    shipOwnerSetSelectedAction(shipOwner)
    history.push(`/ship-owner/edit/${shipOwner.id}`)
  }

  const handleClose = () => setShow(false);
  const handleShow = (shipowner: any) => {
    setShow(true);
    setDeleteShipOwner(shipowner.id)
    // console.log(deleteAnode, 'deleted anode id')
  }

  const _willDelete = () => {
    // console.log(deleteAnode, 'deleted anode id')
    _deleteShipOwner(deleteShipOwner)
  }
  const _willCloseModal = () => {
    setModal(false)
  }
  const _deleteShipOwner = (id: any) => {
    return shipService.deleteShipOwner(id).subscribe({
      next: (r) => {
        // console.log(r, 'response')
        setShow(false);
        swal("Great", " Deleted Successfully", "success")
        props.shipOwnerListGetAction({ size: 10, page })
      },
      error: err => {
        swal("OOPS", String(err), "error")
      }
    })
  }

  const _addSearchHandlers = useCallback(
    () => {
      // console.log('search called')
      const searchInput: HTMLElement | any = document.getElementById('search-input')
      // console.log(searchInput,'searchinput')
      const searchHandler$ = Observable.fromEvent(searchInput, 'keyup').pipe(
        map((e: any) => e.target.value),
        filter(query => query.length >= 4 || query.length === 0),
        debounceTime(750),
        distinctUntilChanged(),
        tap(q => {
          setQuery(q)
        }),
        switchMap(() => Observable.of(props.dockOwnerListGetAction({ size: 10, page: 0 })))
      )
      return searchHandler$.subscribe()
    }, [page, searchQuery]
  );

  const _goPrevPage = () => {
    setPage(prev => {
      return (prev -= 1)
    })
  }

  const _goNextPage = () => {
    setPage(prev => {
      return (prev += 1)
    })
  }

  const _goToPage = (page: any) => {
    setPage(page)
  }

  const firstPage = () => {
    if (page >= 1) {
      return <Pagination.First onClick={() => _goToFirstPage()}>First</Pagination.First>
    }
  }

  const _goToLastPage = () => {
    setPage(totalPage - 1)
    setHigh(totalPage - 1)
    setLow(totalPage - 10)
  }

  const _goToFirstPage = () => {
    setPage(0)
    setHigh(10)
    setLow(1)
  }

  const lastPage = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Last onClick={() => _goToLastPage()}>Last</Pagination.Last>
      }
    }
  }

  const prevBtn = () => {
    if (page >= 1) {
      if (page + 1 === low) {
        setHigh(high - perPage)
        setLow(low - perPage)
      }
      return <Pagination.Prev onClick={() => _goPrevPage()}>Prev</Pagination.Prev>
    }
  }

  const nextBtn = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Prev onClick={() => _goNextPage()}>Next</Pagination.Prev>
      }
      else {
        setHigh(high + perPage)
        setLow(low + perPage)
      }
    }
  }

  const ListItem = (page: any) => {
    return page.value + 1
  }

  const PageNumber = pagination.map((p, i) => {
    var pagination_num: ReactNode;
    if ((p === 0 && page === 0) || (p === 1 && page === 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} key={i} active={p === page}><ListItem value={p} /></Pagination.Item>
    }
    else if ((p < high + 1) && (p >= low - 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} key={i} active={p === page}><ListItem value={p} /></Pagination.Item>
    }
    return (
      pagination_num
    )
  })

  const sortByFieldn=(value:String,directions:String)=>{
    if(directions==='asc')
    {
      setSorting({values:String(value),direction:String(directions)});
      ShipFilterState.shipOwnerFilter.type=String(value);
      ShipFilterState.shipOwnerFilter.direction=String(directions);
      props.shipOwnerListGetAction({
        page: 0, size: 10, name: ShipFilterState.shipOwnerFilter.searchBoxInputName,
        email: searchSEmail || ShipFilterState.shipOwnerFilter.searchBoxInputEmail,
        fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
        toDate: String(ShipFilterState.shipOwnerFilter.toDate),
        shipownstatus: ShipFilterState.shipOwnerFilter.toDate,
        type:value,
        direction:directions
      })
      setPage(0)
      
    }
    else if(directions==='desc')
    {
      setSorting({values:String(value),direction:String(directions)});
      ShipFilterState.shipOwnerFilter.type=String(value);
      ShipFilterState.shipOwnerFilter.direction=String(directions);
      props.shipOwnerListGetAction({
        page: 0, size: 10, name: ShipFilterState.shipOwnerFilter.searchBoxInputName,
        email: searchSEmail || ShipFilterState.shipOwnerFilter.searchBoxInputEmail,
        fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
        toDate: String(ShipFilterState.shipOwnerFilter.toDate),
        shipownstatus: ShipFilterState.shipOwnerFilter.toDate,
        type:value,
        direction:directions
      })
      setPage(0)
    }
    else if(directions==='')
    {
      setSorting({values:String(value),direction:String(directions)});
      ShipFilterState.shipOwnerFilter.type=String(value);
      ShipFilterState.shipOwnerFilter.direction=String(directions);
      props.shipOwnerListGetAction({
        page: 0, size: 10, name: ShipFilterState.shipOwnerFilter.searchBoxInputName,
        email: searchSEmail || ShipFilterState.shipOwnerFilter.searchBoxInputEmail,
        fromDate: String(ShipFilterState.shipOwnerFilter.fromDate),
        toDate: String(ShipFilterState.shipOwnerFilter.toDate),
        shipownstatus: ShipFilterState.shipOwnerFilter.toDate,
        type:value,
        direction:directions
      })
      setPage(0)
    }
    };

  return (
    <Main>
      <Text variant="title">Ship Owner List</Text>
      <Space divheight={15} />
      <Card>
        <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-3 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    {findBy === '' && (
                      <InputWithIcon
                        type="text"
                        value={searchInput}
                        onChange={(e) => _searchFuntion(e.target.value)}
                        placeholder="Search by Owner Name..."
                        icon="search"
                        id="search-input"
                      />
                    )}
                    {findBy === 'name' && (
                      <InputWithIcon
                        type="text"
                        value={searchInput}
                        onChange={(e) => _searchFuntion(e.target.value)}
                        placeholder="Search by Owner Name..."
                        icon="search"
                        id="search-input"
                      />
                    )}
                    {findBy === 'sEmail' && (
                      <InputWithIcon
                        type="text"
                        value={searchSEmail}
                        onChange={(e) => _searchSMailFuntion(e.target.value)}
                        placeholder="Search by Email..."
                        icon="search"
                        id="search-input"
                      />
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs='12' sm='12' md='12' lg='8' xl='8' className='m-0 p-0'>
              <div className='searchOwner-btn-container'>
                <div className='searchOwner-btn-add'>
                  <Select values={findBy} name="" onChange={(e) => _getSearchValue(e.target.value)} >
                    <option value=''>-- Search by --</option>
                    <option value="name"> By Name </option>
                    <option value="sEmail"> By Email </option>
                  </Select>
                </div>
                <div className='searchOwner-btn-filter text-center'>
                  <Button className='link_button filter' onClick={() => _willShipOwnerFilter()}>
                    <img src={Filterimg} alt='filterimg' />
                  </Button>
                </div>
                <div className='searchOwner-btn-showall'>
                  <Button variant='transparent' block={true} onClick={() => _showAllOwner()}>
                    Show All
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </SearchForm>
        <Space divheight={30} />
        {isLoading && <Text center>
          <Loader
            type="Rings"
            color="#233269"
            height={100}
            width={100}
            timeout={30000}
          />
        </Text>}
        {!isLoading && displayShipOwners.length === 0 && (
          <>
            <Space divheight={20} />
            <Text center>No ship Owner found</Text>
            <Space divheight={20} />
          </>
        )}
        {!isLoading && displayShipOwners.length > 0 && (
          <>
            <Table>
              <thead>
                <tr key={0}>
                  <th>S.No</th>
                  <th>Created Date</th>
                  <th>
                    First Name
                    &nbsp;
                    {sort.values==='username' && sort.direction==='asc' ? (
                     <img onClick={() => sortByFieldn('username','desc')} src={sortup}/>
                     ):(null)}
                     {sort.values==='' || sort.values!=='username' ? (
                     <img onClick={() => sortByFieldn('username','asc')} src={sortimage}/>):(null)}
                     {sort.values==='username' && sort.direction==='desc' ? (
                      <img onClick={() => sortByFieldn('','')} src={sortdown}/>
                      ):(null)}
                  </th>
                  {/* <th>Join Date</th> */}
                  <th>
                    Email
                    &nbsp;
                    {sort.values==='email' && sort.direction==='asc' ? (
                     <img onClick={() => sortByFieldn('email','desc')} src={sortup}/>
                     ):(null)}
                     {sort.values==='' || sort.values!=='email' ? (
                     <img onClick={() => sortByFieldn('email','asc')} src={sortimage}/>):(null)}
                     {sort.values==='email' && sort.direction==='desc' ? (
                      <img onClick={() => sortByFieldn('','')} src={sortdown}/>
                      ):(null)}
 
                  </th>
                  <th>Company Name
                  &nbsp;
                    {sort.values==='companyname' && sort.direction==='asc' ? (
                     <img onClick={() => sortByFieldn('companyname','desc')} src={sortup}/>
                     ):(null)}
                     {sort.values==='' || sort.values!=='companyname' ? (
                     <img onClick={() => sortByFieldn('companyname','asc')} src={sortimage}/>):(null)}
                     {sort.values==='companyname' && sort.direction==='desc' ? (
                      <img onClick={() => sortByFieldn('','')} src={sortdown}/>
                      ):(null)}
                  </th>
                  <th>
                    Status
                    &nbsp;
                    {sort.values==='status' && sort.direction==='asc' ? (
                     <img onClick={() => sortByFieldn('status','desc')} src={sortup}/>
                     ):(null)}
                     {sort.values==='' || sort.values!=='status' ? (
                     <img onClick={() => sortByFieldn('status','asc')} src={sortimage}/>):(null)}
                     {sort.values==='status' && sort.direction==='desc' ? (
                      <img onClick={() => sortByFieldn('','')} src={sortdown}/>
                      ):(null)}
 
                  </th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {displayShipOwners.map((dock: any, i: any) => [
                  <tr key={dock.id}>
                    {/* {console.log(dock)} */}
                    <td data-label='S.No'>
                      {page === 0 && (
                        i + 1
                      )}
                      {page >= 1 && (
                        (page * 10) + (i + 1)
                      )}
                    </td>
                    <td data-label='Created Date'>
                      {dock.created_date === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{format(parseISO(dock.created_date), 'dd/MM/yyyy')}</Text>
                      )}
                    </td>
                    <td data-label='First Name'>{dock.name}</td>
                    <td data-label='Email'>{dock.email === null ? (
                      <Text variant='subtitle'> - </Text>
                    ) : (
                      <Text variant='subtitle'>{dock.email}</Text>
                    )}
                    </td>
                    <td data-label='Company Name'>{dock.company_name === null ? (
                      <Text variant='subtitle'> - </Text>
                    ) : (
                      <Text variant='subtitle'>{dock.company_name}</Text>
                    )}
                    </td>
                    <td data-label='Status'>{dock.status === 'VERIFIED' ? (
                      <Text variant='subtitle' color='warning'>Verified</Text>
                    ) : (
                      <Text variant='subtitle' color='danger'>Not Verified</Text>
                    )}
                    </td>
                    <td>
                      <TableActions>
                        <OverlayTrigger overlay={
                          <Tooltip id="shipOwner-view"> View
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewDetail(dock)}>
                            <Icons color="#52575a" icon="visibility" />
                          </Button>
                        </OverlayTrigger>
                        {/* <OverlayTrigger overlay={
                          <Tooltip id="shipOwner-edit"> Edit
                          </Tooltip>
                          }>
                            <Button className='link_button' onClick={() => _willViewEdit(dock)}>
                              <Icons color="#52575a" icon="edit" />
                            </Button>
                        </OverlayTrigger> */}
                        {role === 'VISITOR' ? (
                          <OverlayTrigger overlay={
                            <Tooltip id="shipOwner-delete"> Delete option is not available
                            </Tooltip>
                          }>
                            <Button className='link_button' onClick={() => handleShow(dock)} disabled>
                              <Icons color="#52575a" icon="delete" />
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger overlay={
                            <Tooltip id="shipOwner-delete"> Delete
                            </Tooltip>
                          }>
                            <Button className='link_button' onClick={() => handleShow(dock)}>
                              <Icons color="#52575a" icon="delete" />
                            </Button>
                          </OverlayTrigger>
                        )}
                      </TableActions>
                    </td>
                  </tr>
                ])}
              </tbody>
            </Table>
            <TableFooter>
              <Text>
                {displayShipOwners.length === 1 && (
                  <>
                    <b>
                      {displayShipOwners.length}
                      {/* {((page) * 10) + 1} - {(displayShipOwners.length + (page) * 10)} */}
                    </b> of {totalElement} Ship Owner
                  </>
                )}
                {displayShipOwners.length > 1 && (
                  <>
                    <b>
                      {displayShipOwners.length}
                      {/* {((page) * 10) + 1} - {(displayShipOwners.length + (page) * 10)} */}
                    </b> of {totalElement} Ship Owners
                  </>
                )}
              </Text>
              <Pagination size="sm">
                {firstPage()}
                {prevBtn()}
                {PageNumber}
                {nextBtn()}
                {lastPage()}
              </Pagination>
            </TableFooter>
          </>
        )}
      </Card>
      {showModal && <ShipOwnerFilter onClose={() => _willCloseModal()} />}
      <Modal show={showDelete} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant='title-sm' color='main' bold>
              Confirmation
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text bold variant='confirmation' color='danger' values='Permanently you want to delete this item form ship owner list' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='transparent' onClick={handleClose}>
            <Icons icon="close" />
            Close
          </Button>
          <Button variant='transparent' onClick={() => _willDelete()}>
            <Icons icon="delete_forever" />
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  )
}

export interface TablefooterProps {
  children?: React.ReactNode
}

const TableFooter = (props: TablefooterProps) => {

  const tablefooter = classNames('tablefooter')

  return (
    <Flex jc='jc-between' className={tablefooter}>
      {props.children}
    </Flex>
  )

}

export interface TableActionsProps {
  children?: React.ReactNode
}

const TableActions = (props: TableActionsProps) => {

  const tableAction = classNames('tableAction')

  return (
    <Flex jc='jc-center' className={tableAction}>
      {props.children}
    </Flex>
  )

}

interface searchProps {
  children?: React.ReactNode
}

//Search Form Component  for displaying serarch box, and add ship button
const SearchForm = (props: searchProps) => {

  const search = classNames('serachForm')
  return (
    <form autoComplete='off' className={search}>
      {props.children}
    </form>
  )
}

const mapStateToProps = (state: any) => ({
  owners: state.ship.owners,
  isLoading: state.ship.isLoading,
  error: state.ship.error,
  totalElement: state.ship.totalElement,
  totalPage: state.ship.totalPage
})

export default connect(
  mapStateToProps,
  {
    shipOwnerListGetAction,
    shipOwnerSetSelectedAction
  }
)(ShipOwnerList)